@if (opened()) {
  <div *transloco="let t" class="drawer" data-test-id="sideFiltersContainer">
    <header>
      <h3>{{ t("COMMON.COLLECTIONS.FILTERING.DRAWER.HEADER") }}</h3>
      <chr-button-icon icon="x"
                       palette="neutral"
                       variant="invisible"
                       [attr.aria-label]="t('COMMON.COLLECTIONS.ARIA.BUTTONS.CLOSE')"
                       (chr-action)="closeDrawer()" />
    </header>

    <section class="filters">
      @for (filter of filters(); track filter.key; let i = $index) {
        @switch (filter.type) {
          @case (collectionFilterTypes.Dictionary) {
            <ciphr-dictionary-collection-filter ciphrCollectionFilter
                                                [expanded]="expandedFilterIndex() === i"
                                                [filter]="filter"
                                                (expansionToggle)="toggleFilterExpansion(i)"
                                                (valuesSelectionChange)="setFilterValuesSelection(filter.key, $event.values)" />
          }

          @case (collectionFilterTypes.Date) {
            <ciphr-date-collection-filter ciphrCollectionFilter
                                          [expanded]="expandedFilterIndex() === i"
                                          [filter]="filter"
                                          (expansionToggle)="toggleFilterExpansion(i)"
                                          (valuesSelectionChange)="setFilterValuesSelection(filter.key, $event.values)" />
          }
        }
      }
    </section>

    <section class="action-buttons">
      <chr-button [label]="t('COMMON.COLLECTIONS.FILTERING.DRAWER.ACTIONS.CLEAR_ALL')"
                  palette="neutral"
                  variant="invisible"
                  data-test-id="clearFiltersButton"
                  (chr-action)="clearFilters()" />
      <chr-button [label]="t('COMMON.COLLECTIONS.FILTERING.DRAWER.ACTIONS.FILTER')"
                  palette="accent"
                  variant="tertiary"
                  data-test-id="applyFiltersButton"
                  (chr-action)="setFilters()" />
    </section>
  </div>
}
